(function () {

  function initialise() {

  if (window.__PB_BUILDER_REPAIR_LOADED__) return;

  /* ================================ HELPERS ================================ */

  function readJSON(id, fallback) {

    try {

      const el = document.getElementById(id);

      if (!el) return fallback;

      const txt = (el.textContent || "").trim();

      if (!txt) return fallback;

      return JSON.parse(txt);

    } catch (e) {

      console.warn("[BYO] JSON parse failed:", id, e);

      return fallback;

    }

  }

  function normalise(str) {

    return String(str || "")

      .toLowerCase()

      .replace(/[^a-z0-9]+/g, "");

  }

  function normaliseKey(str) {

    return String(str || "")

      .toLowerCase()

      .replace(/[^a-z0-9]/g, "");

  }

  function roundToWholeDollar(price) {

    const dollars = Math.floor(price);

    const cents = price - dollars;

    if (cents < 0.4) return dollars;

    if (cents > 0.3) return dollars + 1;

    return dollars;

  }

  /* ================================ DATA (FROM LIQUID JSON) ================================ */

  const FRUIT_MULTIPLIERS = readJSON("byo-fruit-multipliers", []);

  const REDIRECT_1KG = readJSON("byo-redirect-1kg", {});

  const REDIRECT_500G = readJSON("byo-redirect-500g", {});

  const CORE_FRUITS = readJSON("byo-core-fruits", []);

  function getFruitMultiplier(title) {

    const key = normalise(title);

    const match = FRUIT_MULTIPLIERS.find((f) => normalise(f.name) === key);

    return match?.multiplier ?? 1;

  }

  const SINGLE_FRUIT_TIERS = { 200: 1.55, 500: 1.2, 1000: 1.0 };

  const CUSTOM_BUILD_UPLIFT = 1.15;

  const FRUITS = (Array.isArray(CORE_FRUITS) ? CORE_FRUITS : []).filter((f) => {

    if (!f) return false;

    if (f.hide === true) return false;

    const s = String(f.hide).toLowerCase().trim();

    return s !== "true" && s !== "1";

  });

  /* ================================ STATE ================================ */

  let target = 0;

  let selected = 0;

  let FRUIT = {};

  let activeVariant = null;

  let basePrice = 0;

  let hasShownBagFullPopup = false;

  let bypassOneKgRedirect = false;

  let bypass500gRedirect = false;

  let hasChosenBagSize = false;

  let openSummaryOnPopupClose = false;

  let isAddingToCart = false;

  const isEditMode = new URLSearchParams(window.location.search).has("_BYO_STATE");

  const editGroup = new URLSearchParams(window.location.search).get("_BYO_GROUP");

  /* ================================ PRICE CARRIER ================================ */

  const PRICE_VARIANT_ID = 45956039901355;

  /* ================================ ELEMENTS ================================ */

  const root = document.querySelector("#byo-builder[data-product-id]:has(#byo-step-2):has(#byo-fruit-grid)");

  const BYO_PRODUCT_ID = Number(root?.dataset.productId || 0);

  const step2 = document.getElementById("byo-step-2");

  const grid = document.getElementById("byo-fruit-grid");

  const drawer = document.getElementById("byo-drawer");

  const summaryList = document.getElementById("byo-summary-list");

  const drawerPrice = document.getElementById("byo-total-price");

  const drawerGrams = document.getElementById("byo-total-weight");

  const addToCartDrawer = document.getElementById("byo-add-cart");

  const mobileSheet = document.getElementById("byo-mobile-sheet");

  const mobileList = document.getElementById("sheet-summary-list");

  const mobilePrice = document.getElementById("sheet-total-price");

  const mobileGrams = document.getElementById("sheet-total-weight");

  const mobileAddBtn = document.getElementById("sheet-add-cart");

  const popup = document.getElementById("byo-popup");

  const popupTitle = document.getElementById("byo-popup-title");

  const popupMessage = popup?.querySelector("p");

  const popupClose = document.getElementById("byo-popup-close");

  if (!root || !grid || !step2 || !drawer || !addToCartDrawer) return;

  window.__PB_BUILDER_REPAIR_LOADED__ = true;

  let blendGift = null;

  try {

    blendGift = window.THBYOGift?.create(root, () => { if (!isAddingToCart) updateSummary(); }, closeSummary) || null;

  } catch (error) {

    console.error('[BYO] Gift controls could not initialise:', error);

  }

  if (!blendGift) {

    const status = root.querySelector('#byo-gift-options [data-status]');

    if (status) status.textContent = 'Gift options could not load. Refresh this page before adding a gift. Ordinary blends can still be built.';

    root.querySelectorAll('#byo-gift-options fieldset').forEach(field => { field.disabled = true; });

  }

  root.querySelectorAll("button").forEach(button => {button.type = "button";});

  /* ================================ TOAST ================================ */

  const toast = document.createElement("div");

  toast.textContent = "✅ Added to cart";

  toast.style.cssText = `

    position: fixed;

    bottom: 110px;

    left: 50%;

    transform: translateX(-50%);

    background: #27ae60;

    color: #fff;

    padding: 12px 18px;

    border-radius: 30px;

    font-weight: 600;

    opacity: 0;

    transition: opacity 0.3s ease;

    z-index: 999999999;

  `;

  document.body.appendChild(toast);

  function showToast() {

    toast.style.opacity = "1";

    setTimeout(() => (toast.style.opacity = "0"), 2200);

  }

  /* ================================ DRAWER CONTROLS ================================ */

  function setViewMixVisibility(visible) {

    const viewBtn = document.getElementById("byo-viewmix-btn");

    if (!viewBtn) return;

    viewBtn.style.display = visible ? "block" : "none";

  }

  function syncFloatingCTAs() {

    const startBtn = document.getElementById("byo-start-btn");

    const viewBtn = document.getElementById("byo-viewmix-btn");

    if (!startBtn || !viewBtn) return;

    if (hasChosenBagSize) {

      startBtn.style.display = "none";

      viewBtn.style.display = "block";

    } else {

      startBtn.style.display = "block";

      viewBtn.style.display = "none";

    }

  }

  function openSummary() {

    setViewMixVisibility(false);

    if (window.innerWidth > 900) drawer.classList.add("open");

    else mobileSheet?.classList.add("open");

  }

  function closeSummary() {

    drawer.classList.remove("open");

    mobileSheet?.classList.remove("open");

    syncFloatingCTAs();

  }

  document.getElementById("byo-drawer-close")?.addEventListener("click", closeSummary);

  document.getElementById("sheet-close")?.addEventListener("click", closeSummary);

  document.getElementById("byo-edit-mix")?.addEventListener("click", closeSummary);

  document.getElementById("byo-edit-mix-mobile")?.addEventListener("click", closeSummary);

  function showPopup(title, message) {

    if (!popup) return;

    if (popupTitle) popupTitle.textContent = title || "Notice";

    if (popupMessage) popupMessage.textContent = message || "";

    popup.style.display = "flex";

  }

  function hidePopup() {

    if (!popup) return;

    popup.style.display = "none";

  }

  popupClose?.addEventListener("click", () => {

    hidePopup();

    if (openSummaryOnPopupClose) {

      openSummaryOnPopupClose = false;

      openSummary();

    }

  });

  function resetMix() {

    selected = 0;

    FRUIT = {};

    FRUITS.forEach((f) => (FRUIT[f.title] = 0));

    hasShownBagFullPopup = false;

    bypassOneKgRedirect = false;

    bypass500gRedirect = false;

    openSummaryOnPopupClose = false;

    hidePopup();

    refreshUI();

  }

  document.getElementById("byo-reset-mix")?.addEventListener("click", resetMix);

  document.getElementById("byo-reset-mix-mobile")?.addEventListener("click", resetMix);

  document.getElementById("byo-viewmix-btn")?.addEventListener("click", openSummary);

  document.getElementById("byo-start-btn")?.addEventListener("click", () => {

    document.getElementById("byo-step-1")?.scrollIntoView({ behavior: "smooth", block: "start" });

  });

  /* ================================ BAG SIZE SELECTION ================================ */

  document.querySelectorAll("input[name='byo-size']").forEach((radio) => {

    radio.addEventListener("change", () => {

      bypassOneKgRedirect = false;

      bypass500gRedirect = false;

      hasShownBagFullPopup = false;

      const raw = (radio.value || "").trim().toLowerCase();

      const match = raw.match(/([\d.]+)\s*(kg|g)/i);

      if (match) {

        const num = parseFloat(match[1]);

        target = match[2].toLowerCase() === "kg" ? num * 1000 : num;

      } else {

        target = parseInt(raw, 10) || 0;

      }

      basePrice = parseFloat(radio.dataset.basePrice) || 0;

      activeVariant = radio.dataset.variant;

      selected = 0;

      FRUIT = {};

      FRUITS.forEach((f) => (FRUIT[f.title] = 0));

      hidePopup();

      document.getElementById("byo-limit-total").textContent = String(target);

      document.getElementById("byo-limit-current").textContent = "0";

      document.getElementById("byo-summary-size").textContent = `${target}g`;

      document.getElementById("sheet-summary-size").textContent = `${target}g`;

      hasChosenBagSize = true;

      syncFloatingCTAs();

      step2.style.display = "block";

      buildGrid();

      updateSummary();

      refreshUI();

    });

  });

  /* ================================ GRID ================================ */

  function buildGrid() {

    grid.innerHTML = "";

    FRUITS.forEach((f) => {

      const tile = document.createElement("div");

      tile.className = "byo-fruit-tile";

      tile.innerHTML = `

        ${f.image ? `<img src="${f.image}" alt="${f.title}">` : ""}

        <strong>${f.title}</strong>

        <button type="button" class="add-btn" data-name="${f.title}" data-grams="50">+ 50g</button>

        <button type="button" class="add-btn" data-name="${f.title}" data-grams="100">+ 100g</button>

        <button type="button" class="remove-btn" data-name="${f.title}" data-grams="50">– 50g</button>

        <button type="button" class="remove-btn" data-name="${f.title}" data-grams="100">– 100g</button>

        <button type="button" class="reset-fruit-btn" data-name="${f.title}">Reset Fruit</button>

        <div id="${f.key}-count">0g selected</div>

      `;

      grid.appendChild(tile);

    });

    attachFruitEvents();

  }

  function attachFruitEvents() {

    grid.querySelectorAll(".add-btn").forEach((btn) =>

      btn.addEventListener("click", () => updateFruit(btn.dataset.name, Number(btn.dataset.grams), "add"))

    );

    grid.querySelectorAll(".remove-btn").forEach((btn) =>

      btn.addEventListener("click", () => updateFruit(btn.dataset.name, Number(btn.dataset.grams), "remove"))

    );

    grid.querySelectorAll(".reset-fruit-btn").forEach((btn) =>

      btn.addEventListener("click", () => resetFruit(btn.dataset.name))

    );

  }

  function resetFruit(name) {

    hasShownBagFullPopup = false;

    openSummaryOnPopupClose = false;

    bypassOneKgRedirect = false;

    bypass500gRedirect = false;

    selected -= FRUIT[name] || 0;

    FRUIT[name] = 0;

    refreshUI();

  }

  function updateFruit(name, grams, mode) {

    if (FRUIT[name] == null) FRUIT[name] = 0;

    if (mode === "remove") {

      bypassOneKgRedirect = false;

      bypass500gRedirect = false;

      const removed = Math.min(grams, FRUIT[name] || 0);

      FRUIT[name] -= removed;

      selected -= removed;

      if (selected < target) hasShownBagFullPopup = false;

      refreshUI();

      return;

    }

    if (mode === "add") {

      if (selected === 0) openSummary();

      if (selected === target) {

        showPopup("Bag already full", "Remove some fruit to make changes.");

        return;

      }

      if (selected + grams > target) {

        const remaining = Math.max(0, target - selected);

        showPopup(

          "Not enough space left",

          `You only have ${remaining}g remaining in your bag. Remove some fruit or choose a smaller amount.`

        );

        return;

      }

      FRUIT[name] += grams;

      selected += grams;

      if (selected === target && !hasShownBagFullPopup) {

        hasShownBagFullPopup = true;

        const isSingleFruit = Object.values(FRUIT).filter((v) => v > 0).length === 1;

        if (!((target === 1000 || target === 500) && isSingleFruit)) {

          openSummaryOnPopupClose = true;

          showPopup("Your bag is full 🎉", "Review your fruit blend below, or remove fruit to make changes.");

        }

      }

      refreshUI();

    }

  }

  /* ================================ UI REFRESH ================================ */

  function getProgressClass(pct) {

    if (pct >= 100) return "full";

    if (pct >= 80) return "high";

    if (pct >= 50) return "mid";

    return "low";

  }

  function refreshUI() {

    const remaining = Math.max(0, target - selected);

    const percent = target > 0 ? Math.min(100, Math.round((selected / target) * 100)) : 0;

    const progressClass = getProgressClass(percent);

    ["byo-progress-fill", "drawer-progress-fill", "sheet-progress-fill"].forEach((id) => {

      const el = document.getElementById(id);

      if (!el) return;

      el.classList.remove("byo-progress-fill", "low", "mid", "high", "full");

      el.classList.add("byo-progress-fill", progressClass);

      el.style.width = `${percent}%`;

    });

    document.getElementById("byo-progress-percent").textContent = `${percent}%`;

    document.getElementById("drawer-progress-percent").textContent = `${percent}%`;

    document.getElementById("sheet-progress-percent").textContent = `${percent}%`;

    const remText = selected < target ? `— ${remaining}g remaining` : "— bag full";

    document.getElementById("byo-progress-remaining").textContent = remText;

    document.getElementById("drawer-progress-remaining").textContent = remText;

    document.getElementById("sheet-progress-remaining").textContent = remText;

    document.getElementById("byo-limit-current").textContent = String(selected);

    grid.querySelectorAll(".add-btn").forEach((btn) => {

      const g = Number(btn.dataset.grams);

      btn.classList.toggle("disabled", remaining < g);

    });

    grid.querySelectorAll(".byo-fruit-tile").forEach((tile) => tile.classList.remove("suggested"));

    if (remaining === 50 || remaining === 100) {

      document

        .querySelectorAll(`.add-btn[data-grams="${remaining}"]:not(.disabled)`)

        .forEach((btn) => btn.closest(".byo-fruit-tile")?.classList.add("suggested"));

    }

    grid.querySelectorAll(".byo-fruit-tile").forEach((tile) => {

      const name = tile.querySelector("strong")?.textContent;

      tile.classList.toggle("selected", !!(name && FRUIT[name] > 0));

    });

    FRUITS.forEach((f) => {

      const el = document.getElementById(`${f.key}-count`);

      if (el) el.textContent = `${FRUIT[f.title] || 0}g selected`;

    });

    if (selected === target && target > 0) {

      addToCartDrawer.classList.remove("disabled");

      mobileAddBtn?.classList.remove("disabled");

    } else {

      addToCartDrawer.classList.add("disabled");

      mobileAddBtn?.classList.add("disabled");

    }

    updateSummary();

  }

  /* ================================ SUMMARY + PRICING ================================ */

  function updateSummary() {

    if (isNaN(basePrice)) return;

    const helper = document.getElementById("byo-dynamic-helper");

    const remaining = Math.max(0, target - selected);

    const fillPct = target > 0 ? selected / target : 0;

    if (helper) {

      if (fillPct >= 0.8 && fillPct < 1) {

        const suggestionFruit = Object.keys(FRUIT).find((n) => FRUIT[n] > 0) || FRUITS[0]?.title || "a fruit";

        helper.style.display = "block";

        helper.textContent = `Add ${remaining}g of ${suggestionFruit} to finish your blend 🍍`;

      } else {

        helper.style.display = "none";

        helper.textContent = "";

      }

    }

    let html = "";

    let weightedSum = 0;

    let dominantSlots = 0;

    let dominantFruitKey = null;

    const totalSlots = target === 200 ? 4 : target === 500 ? 10 : 20;

    FRUITS.forEach((f) => {

      const grams = FRUIT[f.title] || 0;

      if (!grams) return;

      const slots = grams / (target / totalSlots);

      weightedSum += getFruitMultiplier(f.title) * slots;

      if (slots > dominantSlots) {

        dominantSlots = slots;

        dominantFruitKey = f.key;

      }

      html += `

        <div class="byo-summary-row">

          ${f.image ? `<img src="${f.image}" alt="${f.title}" class="byo-summary-thumb">` : ""}

          <div class="byo-summary-text">

            <span class="byo-summary-name">${f.title}</span>

            <span class="byo-summary-grams">${grams}g</span>

          </div>

        </div>

      `;

    });

    summaryList.innerHTML = html;

    if (mobileList) mobileList.innerHTML = html;

    if (dominantFruitKey) {

      const fruitTitle = FRUITS.find((f) => f.key === dominantFruitKey)?.title;

      if (fruitTitle) {

        document

          .querySelector(`.byo-fruit-tile img[alt="${fruitTitle}"]`)

          ?.closest(".byo-fruit-tile")

          ?.classList.add("dominant");

      }

    }

    let finalPrice = basePrice * (weightedSum / totalSlots);

    finalPrice = roundToWholeDollar(finalPrice);

    if (selected === target && SINGLE_FRUIT_TIERS[target]) {

      const chosen = Object.keys(FRUIT).filter((n) => FRUIT[n] > 0);

      if (chosen.length === 1) {

        const fruitKey = normalise(chosen[0]);

        const fruitData = FRUITS.find((f) => normalise(f.title) === fruitKey);

        const kgPrice = parseFloat(fruitData?.standard_1kg_price) || 0;

        if (kgPrice) {

          const tier = SINGLE_FRUIT_TIERS[target];

          const gramsFactor = target / 1000;

          let singleFruitPrice = kgPrice * tier * gramsFactor;

          singleFruitPrice *= CUSTOM_BUILD_UPLIFT;

          if (finalPrice < singleFruitPrice) finalPrice = singleFruitPrice;

        }

      }

    }

    drawerPrice.textContent = `$${finalPrice.toFixed(2)}`;

    if (mobilePrice) mobilePrice.textContent = `$${finalPrice.toFixed(2)}`;

    document.getElementById("byo-summary-price").textContent = `$${finalPrice.toFixed(2)}`;

    document.getElementById("sheet-summary-price").textContent = `$${finalPrice.toFixed(2)}`;

    drawerGrams.textContent = `${selected}g`;

    if (mobileGrams) mobileGrams.textContent = `${selected}g`;

    blendGift?.price(Math.round(finalPrice * 100));

    const purchasePrice = finalPrice + (blendGift?.charge() || 0) / 100;

    const ctaText = blendGift?.actionLabel(isEditMode) || (isEditMode ? "Update Cart" : "Add to Cart");

    addToCartDrawer.textContent = `${ctaText} — $${purchasePrice.toFixed(2)}`;

    if (mobileAddBtn) mobileAddBtn.textContent = `${ctaText} — $${purchasePrice.toFixed(2)}`;

  }

  /* ================================ 1KG / 500G CHOICE DIALOGS ================================ */

  function showChoiceDialog(opts) {

    const { id, title, message, redirectUrl, redirectLabel, onContinue, onReset } = opts;

    const overlay = document.createElement("div");

    overlay.id = id;

    overlay.style.cssText = `

      position: fixed;

      inset: 0;

      background: rgba(0,0,0,0.6);

      display: flex;

      align-items: center;

      justify-content: center;

      z-index: 99999999;

    `;

    overlay.innerHTML = `

      <div style="background:#fff;padding:28px;border-radius:16px;max-width:380px;width:90%;text-align:center;box-shadow:0 10px 30px rgba(0,0,0,0.25);">

        <h3 style="margin-bottom:10px;">${title}</h3>

        <p style="font-size:14px;line-height:1.5;margin-bottom:22px;">${message}</p>

        <div style="display:flex;flex-direction:column;gap:12px;">

          ${

            redirectUrl

              ? `

            <button id="${id}-redirect" style="padding:14px;border-radius:999px;font-weight:700;font-size:15px;border:none;background:#27ae60;color:#fff;cursor:pointer;">

              ${redirectLabel}

            </button>

          `

              : ""

          }

          <button id="${id}-continue" style="padding:14px;border-radius:999px;font-weight:700;font-size:15px;border:2px solid #27ae60;background:#fff;color:#27ae60;cursor:pointer;">

            Continue with this blend

          </button>

          <button id="${id}-reset" style="padding:12px;border-radius:999px;font-weight:600;font-size:14px;border:none;background:#eee;color:#444;cursor:pointer;">

            Reset blend

          </button>

        </div>

      </div>

    `;

    document.body.appendChild(overlay);

    document.getElementById(`${id}-redirect`)?.addEventListener("click", () => {

      window.location.href = redirectUrl;

    });

    document.getElementById(`${id}-continue`)?.addEventListener("click", () => {

      overlay.remove();

      onContinue?.();

    });

    document.getElementById(`${id}-reset`)?.addEventListener("click", () => {

      overlay.remove();

      onReset?.();

    });

  }

  function maybeShowSingleFruitDialog() {

    if (target === 1000 && selected === 1000 && !bypassOneKgRedirect) {

      const chosen = Object.keys(FRUIT).filter((n) => FRUIT[n] > 0);

      if (chosen.length === 1) {

        const fruitName = chosen[0];

        const redirectUrl = REDIRECT_1KG[normalise(fruitName)];

        if (redirectUrl && !document.getElementById("onekg-choice-overlay")) {

          addToCartDrawer.classList.add("disabled");

          mobileAddBtn?.classList.add("disabled");

          showChoiceDialog({

            id: "onekg-choice-overlay",

            title: "Better value available",

            message: `You’ve built a 1kg ${fruitName} blend.\nA standard 1kg pack is better value.`,

            redirectUrl,

            redirectLabel: "Select 1kg Dried Fruit",

            onContinue: () => {

              bypassOneKgRedirect = true;

              refreshUI();

              openSummary();

            },

            onReset: () => resetMix(),

          });

          return true;

        }

      }

    }

    if (target === 500 && selected === 500 && !bypass500gRedirect) {

      const chosen = Object.keys(FRUIT).filter((n) => FRUIT[n] > 0);

      if (chosen.length === 1) {

        const fruitName = chosen[0];

        const redirectUrl = REDIRECT_500G[normalise(fruitName)];

        if (redirectUrl && !document.getElementById("fivehundred-choice-overlay")) {

          addToCartDrawer.classList.add("disabled");

          mobileAddBtn?.classList.add("disabled");

          showChoiceDialog({

            id: "fivehundred-choice-overlay",

            title: "Better value available",

            message: `You’ve built a 500g ${fruitName} blend.\nA standard 500g pack is better value.`,

            redirectUrl,

            redirectLabel: "Select 500g Dried Fruit",

            onContinue: () => {

              bypass500gRedirect = true;

              refreshUI();

              openSummary();

            },

            onReset: () => resetMix(),

          });

          return true;

        }

      }

    }

    return false;

  }

  // Wrap refreshUI to include dialog check (keeps your original behaviour)

  const _origRefresh = refreshUI;

  refreshUI = function () {

    _origRefresh();

    maybeShowSingleFruitDialog();

  };

  /* ================================ RESTORE (EDIT MODE) ================================ */

  function restoreFromQuery() {

    const params = new URLSearchParams(window.location.search);

    const raw = params.get("_BYO_STATE");

    if (!raw) return;

    let state;

    try {

      state = JSON.parse(raw);

    } catch {

      try {

        const fixed = raw.replace(/\\+/g, " ");

        state = JSON.parse(decodeURIComponent(fixed));

      } catch (e) {

        console.error("Invalid _BYO_STATE", e, raw);

        return;

      }

    }

    const savedTarget = Number(state.t ?? state.target) || 0;

    const savedBase = Number(state.b ?? state.basePrice) || 0;

    const savedVar = String(state.v ?? state.activeVariant ?? "") || null;

    const savedFruit = state.f ?? state.FRUIT;

    if (!savedTarget || !savedFruit) return;

    target = savedTarget;

    basePrice = savedBase;

    activeVariant = savedVar;

    FRUIT = {};

    selected = 0;

    const titleByKey = {};

    FRUITS.forEach((f) => {

      const k = normaliseKey(f.title);

      titleByKey[k] = f.title;

      FRUIT[f.title] = 0;

    });

    Object.keys(savedFruit).forEach((savedName) => {

      const grams = Number(savedFruit[savedName]) || 0;

      if (!grams) return;

      const key = normaliseKey(savedName);

      const matchTitle = titleByKey[key];

      if (!matchTitle) return;

      FRUIT[matchTitle] = (FRUIT[matchTitle] || 0) + grams;

      selected += grams;

    });

    document.querySelectorAll("input[name='byo-size']").forEach((radio) => {

      const rawVal = String(radio.value || "").toLowerCase();

      const m = rawVal.match(/([\d.]+)\s*(kg|g)/i);

      if (!m) return;

      const grams = m[2].toLowerCase() === "kg" ? parseFloat(m[1]) * 1000 : parseFloat(m[1]);

      if (Number(grams) === Number(target)) {

        radio.checked = true;

        basePrice = parseFloat(radio.dataset.basePrice) || basePrice;

        activeVariant = radio.dataset.variant || activeVariant;

      }

    });

    hasChosenBagSize = true;

    syncFloatingCTAs();

    document.getElementById("byo-limit-total").textContent = String(target);

    document.getElementById("byo-limit-current").textContent = String(selected);

    document.getElementById("byo-summary-size").textContent = `${target}g`;

    document.getElementById("sheet-summary-size").textContent = `${target}g`;

    step2.style.display = "block";

    buildGrid();

    refreshUI();

    openSummary();

  }

  /* ================================ ADD TO CART ================================ */

  async function cartRequest(path, body) {

    const response = await fetch((window.Shopify?.routes?.root || "/") + path, {

      credentials: "same-origin", cache: "no-store",

      ...(body ? {method: "POST", headers: {"Content-Type": "application/json"}, body: JSON.stringify(body)} : {})

    });

    const data = await response.json();

    if (!response.ok) throw new Error(data.description || data.message || "Cart request failed");

    return data;

  }

  async function addToCart(id) {

    if (isAddingToCart || !id || selected !== target || target <= 0 || addToCartDrawer.classList.contains("disabled")) return;

    if (isEditMode && !editGroup) {

      showPopup("This older blend cannot be updated safely", "Remove the original blend from your cart, then build a new blend. Your other cart items will stay in place.");

      return;

    }

    if (!blendGift && root.querySelector('[name="byo-gift-choice"]:checked') && root.querySelector('[name="byo-gift-choice"]:checked').value !== 'none') {

      showPopup('Gift options have not loaded', 'Please refresh this page before adding a gift. You can still choose No gift for an ordinary blend.'); return;

    }

    const totalCents = Math.round(parseFloat(drawerPrice.textContent.replace(/[^0-9.]/g, "")) * 100);

    if (!Number.isFinite(totalCents) || totalCents < 1) {

      showPopup("Pricing unavailable", "Please check the selected bag size and try again."); return;

    }

    isAddingToCart = true;

    [addToCartDrawer, mobileAddBtn].filter(Boolean).forEach(button => {

      button.disabled = true; button.classList.add("disabled");

      button.textContent = isEditMode ? "Updating..." : "Adding...";

    });

    const compactFruit = {};

    Object.keys(FRUIT).forEach(name => {if (FRUIT[name] > 0) compactFruit[name] = FRUIT[name];});

    const byoGroup = `pb_${Date.now()}_${Math.random().toString(16).slice(2)}`;

    const properties = {

      "Bag size": `${target}g`,

      "Your blend": Object.entries(compactFruit).map(([name, grams]) => `${grams}g Dried ${name}`).join("\n"),

      "_Total weight": `${selected}g`, "_byo_group": byoGroup, "_byo_price_cents": String(totalCents),

      "_BYO_STATE": JSON.stringify({t: target, b: basePrice, v: activeVariant, f: compactFruit})

    };

    let originalKeys = [];

    try {

      const giftResult = blendGift && await blendGift.submit({id:Number(id),quantity:1,properties},

        {id:PRICE_VARIANT_ID,quantity:totalCents,properties:{_byo_carrier:'true',_byo_group:byoGroup}});

      if (giftResult) {

        window.location.href = typeof giftResult === 'string' ? giftResult : (window.Shopify?.routes?.root || '/') + 'cart'; return;

      }

    } catch(error) {

      console.error('[BYO gift]',error);

      showPopup('Please check your gift',error.message || 'Review your cart before trying again.');

      isAddingToCart=false;

      [addToCartDrawer,mobileAddBtn].filter(Boolean).forEach(b=>{b.disabled=false;});refreshUI();return;

    }

    try {

      // Without the integration asset, never strip gift markers from an existing blend.

      if (!blendGift && isEditMode) {

        const checked = await cartRequest('cart.js');

        if (checked.items.some(i => i.properties?._byo_group === editGroup && i.properties?.['_Gift reference']))

          throw new Error('Gift integration did not load. Refresh this page before editing this gift blend.');

      }

      if (isEditMode) {

        const before = await cartRequest("cart.js");

        originalKeys = before.items.filter(item => item.properties?._byo_group === editGroup &&

          (String(item.product_id) === String(BYO_PRODUCT_ID) || item.properties?._byo_carrier === "true" || String(item.variant_id) === String(PRICE_VARIANT_ID))).map(item => item.key);

        if (!originalKeys.length) throw new Error("The original blend is no longer in your cart. Return to your cart and start a new blend.");

      }

      // Add both new lines in one request before removing the original paid blend.

      await cartRequest("cart/add.js", {items: [

        {id, quantity: 1, properties},

        {id: PRICE_VARIANT_ID, quantity: totalCents, properties: {_byo_carrier: "true", _byo_group: byoGroup}}

      ]});

      if (originalKeys.length) await cartRequest("cart/update.js", {updates: Object.fromEntries(originalKeys.map(key => [key, 0]))});

      showToast();

      window.location.href = (window.Shopify?.routes?.root || "/") + "cart";

    } catch (error) {

      let rollbackFailed = false;

      // A lost response can still have added items: inspect this unique new group.

      try {

        const current = await cartRequest("cart.js");

        const newItems = current.items.filter(item => item.properties?._byo_group === byoGroup);

        const originalStillPresent = current.items.some(item => originalKeys.includes(item.key));

        // An update may have succeeded even if its response was lost.

        if (isEditMode && originalKeys.length && !originalStillPresent && newItems.length === 2) {

          window.location.href = (window.Shopify?.routes?.root || "/") + "cart";

          return;

        }

        if (newItems.length) await cartRequest("cart/update.js", {updates: Object.fromEntries(newItems.map(item => [item.key, 0]))});

      } catch (rollbackError) {rollbackFailed = true; console.error("[BYO rollback]", rollbackError);}

      console.error("[BYO cart]", error);

      showPopup("Your blend was not confirmed", rollbackFailed

        ? "Please open your cart and check it before trying again. The latest change could not be confirmed."

        : (error.message || "Please try again. Your original blend has been kept where possible."));

    } finally {

      isAddingToCart = false;

      [addToCartDrawer, mobileAddBtn].filter(Boolean).forEach(button => {button.disabled = false;});

      refreshUI();

    }

  }

  addToCartDrawer?.addEventListener("click", () => addToCart(activeVariant));

  mobileAddBtn?.addEventListener("click", () => addToCart(activeVariant));

  /* ================================ INIT ================================ */

  syncFloatingCTAs();

  FRUITS.forEach(f => {FRUIT[f.title] = 0;});

  if (isEditMode) restoreFromQuery();

  else {

    const checked = document.querySelector("input[name='byo-size']:checked");

    if (checked) checked.dispatchEvent(new Event("change", {bubbles: true}));

  }

  }

  document.readyState === "loading"

    ? document.addEventListener("DOMContentLoaded", initialise, {once: true})

    : initialise();

})();